const features = [
  {
    icon: 'ri-shield-check-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    title: '正版授权',
    desc: '与国内外多家出版社及版权方建立合作，皮皮漫画韩漫、日漫与国漫内容均获正版授权，阅读更安心。',
  },
  {
    icon: 'ri-smartphone-line',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
    title: '全端适配',
    desc: '支持手机、平板、电脑多端同步阅读，自适应屏幕尺寸，随时随地畅享皮皮漫画在线阅读体验。',
  },
  {
    icon: 'ri-speed-up-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-600',
    title: '极速更新',
    desc: '热门漫画每日同步更新，汉化组第一时间翻译发布，确保读者不错过皮皮漫画任何精彩章节。',
  },
  {
    icon: 'ri-eye-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    title: '完全免费',
    desc: '皮皮漫画所有内容均为免费阅读，无隐藏收费项目。通过广告赞助模式支撑平台运营，为读者提供零门槛阅读体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">平台特色</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            为什么选择皮皮漫画？四大核心优势为你打造最佳阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100 rounded-2xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200 transition-all duration-300 text-center group cursor-pointer"
            >
              <div className={`w-14 h-14 mx-auto rounded-2xl flex items-center justify-center ${feature.iconBg} group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-2xl ${feature.iconColor}`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-950 mt-5 mb-3">{feature.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}